/**
 * @param {string} state - opaque value round-tripped by Cognito back to the callback's searchParams (e.g. register invite context)
 */
export const buildCognitoGoogleLoginUrl = (state?: string) => {
  const domain = process.env.REACT_APP_AWS_COGNITO_DOMAIN ?? "";
  const clientId = process.env.REACT_APP_AWS_COGNITO_CLIENT_ID ?? "";
  const redirectUri = process.env.REACT_APP_AWS_COGNITO_CALLBACK_URI ?? "";

  return (
    `${domain}/oauth2/authorize?` +
    `client_id=${clientId}&` +
    `response_type=code&` +
    `scope=openid+email+phone&` +
    `redirect_uri=${encodeURIComponent(redirectUri)}&` +
    `identity_provider=Google&` +
    `prompt=select_account&` +
    `max_age=0` +
    (state ? `&state=${encodeURIComponent(state)}` : "")
  );
};
